export const changeToTitleCase = (words) =>
    words ? words
        .split(' ')
        .map((w) => w.substring(0, 1).toUpperCase() + w.substring(1).toLowerCase())
        .join(' ') : words;

export const getConversationMessageCount = (conversation) =>
    conversation?.messageCount ?? conversation?.conversationVersion ?? 1;

export const formatInAppMessageHtml = (message) =>
    String(message || '').replace(/{{break}}/g, '<br />');
